import {isUndefined } from "lodash";

export function getAuthUserID(userState) {
  return userState?.user?.id;
}

export function isYoursAccount(userState, id) {
    if (isUndefined(id) || isUndefined(getAuthUserID(userState))) return false

    return getAuthUserID(userState) === id;
}

export function userHasAllNodes(nodes) {
    let result = 0;

    if (nodes?.all) {
      Object.keys(nodes.all).map(city => {
          result += Object.keys(nodes.all[city]).length
      })
    }
  
    return result !== 0;
}

export function userHasNodesForCity(userNodes, city, type) {
    let result = 0;
  
    if (userNodes?.all && userNodes?.all?.[city]) {
      Object.keys(userNodes.all[city]).map(type => {
        result += userNodes.all[city][type]
      })
    }

    if (userNodes?.singleton && userNodes?.singleton?.[city]) {
      if (type) {
        result += userNodes.singleton[city][type]
      }
      else { 
        Object.keys(userNodes.singleton[city]).map(t => {
          result += userNodes.singleton[city][t]
        })
      }
    }
  
    return result > 0;
}

export function userHasBooks(library, city) {
    let result = 0;
  
    if (library[city]?.owner) result += library[city].owner
  
    if (library[city]?.reading) result += library[city].reading

    return result > 0;
}
  
export function userHasNetworking(nodes, city) {
    return nodes?.singleton?.[city]?.['networking'];
}
